import { IDisplayBidNFA, IDisplayBidPairing } from "@vmosolutions/oc-interfaces";
import { BaseTimelineGL } from "src/SharedGL/BaseTimelineGL";
import { Camera } from "src/SharedGL/Camera";
import { ICrewGL } from "./CrewScheduleGL";
import { crewBidRowHeight } from "src/components/CrewSchedule/CrewMemberBidding";
import { ICrewEvent } from "src/redux/reducers/CrewScheduleReducer";

const pairingHeight = 25;
const doubleArrowSpacing = 5;
const arrowHeight = 10;
const lineWidth = 2;

/**
 * Function which draws double arrows (pointing up or down) when users hover over bid events.
 * Function which draws double arrows (pointing up or down) when userconsoles hover over bid events.
 * @param canvasCtx -
 * @param camera -
 * @param crewGL -
 * @param hoveredEvents -
 * @returns
 */
export function drawBidAssignmentIndicators(
  canvasCtx: CanvasRenderingContext2D,
  camera: Camera,
  crewGL: ICrewGL,
  hoveredEvents: ICrewEvent[],
  rowStart: number,
  BiddingNFARowHeight: number
): void {
  const hoveredBidEvents = hoveredEvents
    ?.filter((hov) => {
      return (hov.event as IDisplayBidPairing | IDisplayBidNFA)?.hasOwnProperty("prefRank");
    })
    ?.map((hov) => hov.event) as (IDisplayBidPairing | IDisplayBidNFA)[];

  if (hoveredBidEvents?.length === 0) {
    return;
  }

  //!! If this function is modified in any way, make certain the one located in the BaseTimelineLabelsGL at line 213 is modified to match.
  if (hoveredBidEvents?.length > 0) {
    const [yMin] = camera.getYRange();
    const y0: number = crewGL.rowStart + BaseTimelineGL.timelineStart;
    const delta: number = y0 - yMin;
    canvasCtx.save();

    // PAINT ALL ARROWS
    hoveredBidEvents?.forEach((bp) => {
      const pointingUpGreen = (!bp.assigned && !bp.awarded) || (bp.assigned && bp.awarded);
      const midX = bp.start?.valueOf() + (bp.end?.valueOf() - bp.start?.valueOf()) / 2;
      const triangleWidth = pointingUpGreen ? 6 : -6;
      const xStart = camera.timeAxisToPixelCoords(midX, canvasCtx.canvas.width) - Math.abs(triangleWidth);
      const crewBoxHeights = { crewBox: 48, gridPadding: 8, prefRankPadding: 4 };
      const yStart =
        window.devicePixelRatio *
        (rowStart +
          BaseTimelineGL.timelineStart +
          BiddingNFARowHeight +
          crewBidRowHeight * bp.prefRank +
          crewBoxHeights.gridPadding +
          crewBoxHeights.prefRankPadding * bp.prefRank +
          arrowHeight +
          crewBoxHeights.crewBox);
      const triangleStart = pointingUpGreen ? yStart : yStart - 7;
      canvasCtx.lineWidth = lineWidth;
      canvasCtx.strokeStyle = pointingUpGreen ? "green" : "darkred";
      canvasCtx.fillStyle = "#cccccc";
      canvasCtx.fillRect(xStart - 4, yStart - 10, crewBidRowHeight + 5, crewBidRowHeight + 4);
      canvasCtx.beginPath();
      canvasCtx.moveTo(xStart, triangleStart);
      canvasCtx.lineTo(xStart + Math.abs(triangleWidth), triangleStart - triangleWidth);
      canvasCtx.stroke();
      canvasCtx.lineTo(xStart + Math.abs(triangleWidth) * 2, triangleStart);
      canvasCtx.stroke();
      canvasCtx.moveTo(xStart, triangleStart + doubleArrowSpacing);
      canvasCtx.lineTo(xStart + Math.abs(triangleWidth), triangleStart - triangleWidth + doubleArrowSpacing);
      canvasCtx.stroke();
      canvasCtx.lineTo(xStart + Math.abs(triangleWidth) * 2, triangleStart + doubleArrowSpacing);
      canvasCtx.stroke();
      canvasCtx.beginPath();
    });
    canvasCtx.restore();
  }
}
